import { render, staticRenderFns } from "./performanceProductComponent.vue?vue&type=template&id=691233c8&scoped=true&"
import script from "./performanceProductComponent.vue?vue&type=script&lang=js&"
export * from "./performanceProductComponent.vue?vue&type=script&lang=js&"
import style0 from "./performanceProductComponent.vue?vue&type=style&index=0&id=691233c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691233c8",
  null
  
)

export default component.exports